import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {container, down, eyebrow, focusRing} from "../../../Styles/media";

const Footer = styled.footer`
    position: relative;
    margin-top: auto;
    padding-top: clamp(56px, 8vw, 96px);
    border-top: 1px solid ${({theme}) => theme.line};
    background-color: ${({theme}) => theme.surfaceSunken};

    ${down('md')} {
        padding-top: 44px;
    }
`

const Inner = styled.div`
    ${container};
`

const Top = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1.4fr) repeat(3, minmax(0, 1fr));
    gap: clamp(28px, 5vw, 64px);
    padding-bottom: clamp(40px, 6vw, 72px);

    ${down('lg')} {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    ${down('sm')} {
        gap: 28px 20px;
        padding-bottom: 32px;
    }

    ${down('xs')} {
        grid-template-columns: minmax(0, 1fr);
    }
`

const Brand = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 18px;

    ${down('sm')} {
        grid-column: 1 / -1;
        gap: 12px;
    }
`

const Logo = styled.button`
    ${focusRing};
    font-family: ${({theme}) => theme.font.logo};
    font-size: 54px;
    line-height: 0.9;
    color: ${({theme}) => theme.color};

    &:hover {
        color: ${({theme}) => theme.accent};
    }
`

const Claim = styled.p`
    max-width: 34ch;
    font-size: 15px;
    line-height: 1.6;
    color: ${({theme}) => theme.colorMuted};
`

const ColumnTitle = styled.div`
    ${eyebrow};
    margin-bottom: 18px;
`

const Column = styled.div`
    display: flex;
    flex-direction: column;
`

const LinkList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 11px;
    list-style: none;
`

const LinkItem = styled.li`
    display: flex;
`

const LinkButton = styled.button`
    ${focusRing};
    position: relative;
    font-size: 15px;
    font-weight: 500;
    text-align: left;
    color: ${({theme}) => theme.colorMuted};
    transition: color 200ms ${({theme}) => theme.ease.out}, transform 200ms ${({theme}) => theme.ease.out};

    &:hover {
        color: ${({theme}) => theme.color};
        transform: translateX(3px);
    }
`

const ExternalLink = styled.a`
    ${focusRing};
    display: inline-flex;
    align-items: center;
    gap: 9px;
    font-size: 15px;
    font-weight: 500;
    color: ${({theme}) => theme.colorMuted};
    transition: color 200ms ${({theme}) => theme.ease.out}, transform 200ms ${({theme}) => theme.ease.out};

    &:hover {
        color: ${({theme}) => theme.color};
        transform: translateX(3px);
    }
`

const LinkIcon = styled(FontAwesomeIcon)`
    width: 13px;
    height: 13px;
    color: ${({theme}) => theme.accent};
`

const Bottom = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 22px 0 26px;
    border-top: 1px solid ${({theme}) => theme.lineFaint};

    ${down('sm')} {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }
`

const Copyright = styled.span`
    font-size: 13px;
    color: ${({theme}) => theme.colorFaint};
`

const BackToTop = styled.button`
    ${focusRing};
    display: inline-flex;
    align-items: center;
    gap: 9px;
    margin-left: auto;
    font-size: 13px;
    font-weight: 600;
    color: ${({theme}) => theme.colorMuted};
    transition: color 200ms ${({theme}) => theme.ease.out};

    &:hover {
        color: ${({theme}) => theme.color};
    }

    ${down('sm')} {
        margin-left: 0;
    }
`

const Watermark = styled.div`
    ${container};
    overflow: hidden;
    padding-bottom: 8px;
    font-family: ${({theme}) => theme.font.logo};
    font-size: clamp(72px, 20vw, 260px);
    line-height: 0.8;
    letter-spacing: 0.02em;
    text-align: center;
    color: transparent;
    -webkit-text-stroke: 1px rgba(255, 255, 255, 0.07);
    user-select: none;
    pointer-events: none;
`

export const Styled = {
    Footer,
    Inner,
    Top,
    Brand,
    Logo,
    Claim,
    Column,
    ColumnTitle,
    LinkList,
    LinkItem,
    LinkButton,
    ExternalLink,
    LinkIcon,
    Bottom,
    Copyright,
    BackToTop,
    Watermark
}
